import { useDialog } from "../../../services/app/providers/dialog-provider"

export class DistanciaModel {
    constructor(
        public latitude: number = 0,
        public longitude: number = 0
    ) { }
}

const PERMISSION_DENIED = 1

export const useGetLocalizacaoUsuario = () => {
    const { abrirPermissaoLocalizacao } = useDialog()

    const obterLocalizacao = (): Promise<DistanciaModel> => {
        return new Promise((resolve, reject) => {
            console.log('Entrou na função obterLocalizacao.')
            if ('geolocation' in navigator) {
                const options: PositionOptions = {
                    enableHighAccuracy: false,
                    timeout: 15000,
                    maximumAge: 60000,
                }
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        const { latitude, longitude } = position.coords;
                        resolve({ latitude, longitude });
                    },
                    (error) => {
                        if (error.code === PERMISSION_DENIED) {
                            abrirPermissaoLocalizacao();
                            reject(new Error('Permissão de localização negada.'));
                        } else {
                            reject(error);
                        }
                    },
                    options
                );
            } else {
                console.log('localizacao', 'Geolocalização não suportada.')
                reject(new Error('Geolocalização não suportada.'));
            }
        });
    }

    return {
        obterLocalizacao,
    }
}
